<template>
  <v-container>
  <h1>Welcome to Effort Tracking</h1>
  </v-container>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      isTeacher: false,
      isStudent: false
    }
  },
  mounted() {
    this.isStudent = (this.$store.state.usertype == 'student' ? true : false);
    this.isTeacher = (this.$store.state.usertype == 'teacher' || this.$store.state.usertype == 'middlemanager' ? true : false);
    var userId = this.$store.state.userdata.id;

    if(this.isTeacher)
      window.location.href = `#/teacher/${userId}/teacher-efforts`;
    
    if(this.isStudent)
      window.location.href = `#/student/${userId}/student-efforts`;
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue